module.exports = __webpack_public_path__ + "static/media/urbangoo20.e3c2b795.webp";